












































































































import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import { mapGetters } from "vuex";
import i18n from "@/i18n";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IClientAuthProviderForm } from "@/models/providers/clientAuth";
import { IBrand } from "@/models/brands";
import { IClientAuthProviderData } from "@/models/providers/clientAuth";

@Component({
  components: {
    "terms-and-conditions-statement": () =>
      import("@/components/app/global/auth/termsAndConditionsStatement.vue"),
    "phone-number-field": () =>
      import("@/components/app/global/fields/phoneNumberField.vue"),
    "custom-fields": () =>
      import("@/components/app/global/customFields/customFields.vue")
  },
  computed: {
    ...mapGetters({
      brandId: "brand/id"
    })
  }
})
export default class ClientAuthRegisterFields extends Vue {
  // Refs

  public $refs!: {
    customFields: HTMLFormElement;
  };

  // Imports

  @Inject({ from: "clientAuthProviderData" })
  public readonly clientAuthProviderData!: () => IClientAuthProviderData;

  // Props

  @Prop({ required: true })
  public value!: IClientAuthProviderForm;

  @Prop({ default: true })
  public passwordRequired!: boolean;

  @Prop({ default: false })
  public isProcessing!: boolean;

  @Prop({ default: () => i18n.t("_action.continue") })
  public termsAndConditionsLabel!: string;

  // Variables

  public customFieldsDataModule = DataModules.CUSTOM_FIELDS_CLIENTS;
  public brandId!: IBrand["id"];

  // Computed

  public get $clientAuthData() {
    return this.clientAuthProviderData();
  }

  // Getter / Setter

  public get form() {
    return this.value;
  }

  public set form(value) {
    this.$emit("input", value);
  }

  // Methods

  public uploadCustomImages() {
    return this.$refs.customFields.uploadCustomImages(true);
  }
}
